import { render, staticRenderFns } from "./CompletedTenders.vue?vue&type=template&id=845a0caa"
import script from "./CompletedTenders.vue?vue&type=script&lang=js"
export * from "./CompletedTenders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports